const NBCIUSCAPartyMasterApiUrls = {
  GET: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/usca-party-master/get`,
  POST: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/usca-party-master/create`,
  PUT: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/usca-party-master/update`,
  DELETE: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/usca-party-master/delete`,
  EXPORT: `${process.env.REACT_APP_USER_NBCI_URL}/nbci/usca-party-master/download`
};

export default NBCIUSCAPartyMasterApiUrls
